import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useRecommendations } from '../../../hooks/use-recommendations.hook';
import { GridPageStripContent } from '../GridPageStripContent';
import { GridPageStripGames } from '../GridPageStripGames';
import { useTranslations } from '../../../../../shared/src/hooks/use-translations.hook';
import { GamesService } from '../../../../../shared/src/services/games.service';

export const GridPageStripGamesRecommendationsLoggedIn = ({ strip }) => {
    const { gamesById } = useSelector(state => state.casino);
    const { recommendedGames } = useRecommendations();
    const { t } = useTranslations();
    const [headerTitle, setHeaderTitle] = useState(t('favourites'));

    const recommendationsSource = recommendedGames?.find(
        item => item?.category?.name === strip.recommendationModel
    );
    const games = recommendationsSource?.games || [];
    const gamesIds = games
        .map(({ gameId }) => gameId)
        .filter(gameId => gamesById?.[gameId]);

    useEffect(() => {
        const categoryName = recommendationsSource?.category?.name;
        setHeaderTitle(categoryName
            ? GamesService.replaceGameName(
                t(categoryName),
                recommendationsSource.category?.gameId,
                gamesById,
            )
            : null
        );
    }, [recommendationsSource, gamesById]);

    if (gamesIds.length === 0) {
        return null;
    }

    return (
        <GridPageStripContent headerTitle={headerTitle}>
            <GridPageStripGames strip={strip} games={gamesIds} />
        </GridPageStripContent>
    );
};
